import { makeAutoObservable } from 'mobx'
import { type BillingInterval, type IResponsePlan } from 'entities/Billing/api/types'

export const basicMonthlyMaxCredits = 7500
export const basicAnnualMaxCredits = 90000

export class BillingPlan {
  id: string
  active: boolean
  interval: BillingInterval
  contract_term: BillingInterval
  credits: number
  for_clients: boolean
  for_users: boolean
  numbers = 0
  seats = 0

  private _price = 0
  private _additional_credit_price = 0

  origin: IResponsePlan

  constructor(item: IResponsePlan) {
    this.id = item.id
    this.active = item.active
    this.interval = item.interval === 'yearly' ? 'annual' : item.interval
    this.contract_term = this.interval

    this.credits = item.credits
    this.for_clients = item.for_clients
    this.for_users = item.for_users

    this._price = item.price
    this._additional_credit_price = item.additional_credit_amount

    this.origin = item

    makeAutoObservable(this)
  }

  get stripe_id() {
    return this.id
  }

  get additional_credit_price() {
    return this._additional_credit_price
  }

  get credit_price() {
    return this.price_dollars / this.credits
  }

  get price_cents() {
    return this._price * 100
  }

  get price_dollars() {
    return this._price
  }

  get price_add() {
    const priceAdd =
      Math.round(Math.abs(this.credits * this.credit_price - this.price_dollars) * 100) / 100

    if (this.credits * this.credit_price > this.price_dollars) {
      return -priceAdd
    }

    return priceAdd
  }

  get label() {
    const interval = this.interval === 'monthly' ? 'Monthly' : 'Yearly'
    const credits = Intl.NumberFormat('en', { notation: 'compact' }).format(this.credits)

    return `Pro ${interval} ${credits}`
  }

  get labelCreditsByInterval() {
    const interval = this.interval === 'monthly' ? 'month' : 'year'
    const credits = Intl.NumberFormat('en').format(this.credits)

    return `${credits} credits / ${interval}`
  }

  get labelCreditsByIntervalAndPlanType() {
    const maxCredits = this.interval === 'monthly' ? basicMonthlyMaxCredits : basicAnnualMaxCredits
    const planType = this.credits <= maxCredits ? 'Basic' : 'Pro'
    const interval = this.interval === 'monthly' ? 'Monthly' : 'Annual'
    const credits = Intl.NumberFormat('en', { notation: 'compact' }).format(this.credits)

    return `${planType} ${interval} ${credits}`
  }
}
